module.exports = __webpack_public_path__ + "static/img/diyiimg.b2f2041.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardiobrain/diyiimg.png
// module id = V+lW
// module chunks = 5